(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["link-linking-blocks"] && !Shopify.designMode) return;
  try {
    
    // $(".link-linking-blocks .blocks-container").slick({
    //   infinite: false,
    //   dots: false,
    //   arrow: false,
    //   speed: 300,
    //   slidesToShow: 5,
    //   slidesToScroll: 1,
    //   prevArrow: false,
    //   nextArrow: false,
    //   variableWidth: true,
    //   responsive: [
    //     {
    //       breakpoint: 1000,
    //       settings: {
    //         slidesToShow: 4,
    //       },
    //     },
    //     {
    //       breakpoint: 950,
    //       settings: {
    //         slidesToShow: 3,
    //       },
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: 1,
    //       },
    //     }
    //   ]
    // });

    $('.link-linking-blocks .blocks-container').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });

  } catch(e) { console.error(e); }
})();
})();
